import React, { useState } from "react";
import "./OverView.css";
import "./Faq.css";
import { BsPlusLg } from "react-icons/bs";

const data = [
  {
    question: "What is the iAssetMax™ Application Suite?",
    answer:
      "iAssetMax™ is a set of applications for asset deployment, monitoring, management, predictive maintenance and reliability planning. It brings configurable CMMS, EAM and APM applications together in a single platform, with shared data and workflows.",
  },
  {
    question: "How is iAssetMax™ better than managing assets in Excel?",
    answer:
      "Spreadsheets scatter asset information across files and people. With a cloud-based asset management system, records are centralized, accurate and auditable, workflows are automated, and you can track every asset from purchase to disposal, including automatic depreciation calculation.",
  },
  {
    question: "How does iAssetMax™ track assets?",
    answer:
      "You can use asset tags, barcodes, QR codes or RFID to monitor an asset's location, condition and maintenance history. Features such as geo tagging, floor mapping, an asset register and asset transactions give you full visibility of where your assets are.",
  },
  {
    question: "Can iAssetMax™ predict equipment failures?",
    answer:
      "Yes. Predictive maintenance uses real-time data, data analysis and machine learning to identify potential asset failures before a breakdown occurs. Combined with IoT-based remote monitoring, it helps you optimize maintenance schedules, extend asset life and reduce downtime and costs.",
  },
  {
    question: "Is there a free trial, and which industries does iAssetMax™ support?",
    answer:
      "You can start a 15-day free trial and explore the suite, including iAssetMax™ Health. The platform is used across digital solutions, energy and utilities, government, healthcare, manufacturing, mining and heavy machines, and travel and transportation. It also has a mobile EAM application so you can manage assets on the go.",
  },
];

const Faq = () => {
  const [openIndex, setOpenIndex] = useState(null);
  const toggle = (i) => setOpenIndex((prev) => (prev === i ? null : i));

  return (
    <section
      className="WhyAM mx-auto w-full max-w-[110rem] px-5 sm:px-14 font-['Poppins',sans-serif]"
      id="Faq"
    >
      <div className="grid gap-10 lg:grid-cols-[22rem_1fr] lg:gap-20">
        <div>
          {/* <div className="inline-block rounded-full bg-[#002C78]/10 px-4 py-1 text-xs font-semibold uppercase tracking-wider text-[#002C78] mb-4">
            Support
          </div> */}
          <h2 className="text-3xl sm:text-4xl font-bold leading-tight text-[#002C78]">
            Frequently Asked Questions
          </h2>
          <div className="w-20 h-1 bg-[#F23100] mt-4 mb-6"></div>
          <p className="text-[#4b5563] text-base leading-relaxed">
            Have questions about iAssetMax™? Find clear answers to common questions about deployment, tracking, and capabilities.
          </p>
        </div>

        <div>
          {data.map((item, i) => {
            const open = openIndex === i;
            return (
              <div className="am-faq-item" key={item.question}>
                <h3>
                  <button
                    type="button"
                    className="am-faq-q"
                    aria-expanded={open}
                    aria-controls={`faq-panel-${i}`}
                    id={`faq-button-${i}`}
                    onClick={() => toggle(i)}
                  >
                    <span>{item.question}</span>
                    <span className="am-faq-icon" aria-hidden="true">
                      <BsPlusLg />
                    </span>
                  </button>
                </h3>
                <div
                  className="am-faq-a"
                  data-open={open}
                  id={`faq-panel-${i}`}
                  role="region"
                  aria-labelledby={`faq-button-${i}`}
                >
                  <div>
                    <p>{item.answer}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Faq;
